import { render, staticRenderFns } from "./DashCompraVenta.vue?vue&type=template&id=158f0881&scoped=true"
import script from "./DashCompraVenta.vue?vue&type=script&lang=js"
export * from "./DashCompraVenta.vue?vue&type=script&lang=js"
import style0 from "./DashCompraVenta.vue?vue&type=style&index=0&id=158f0881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f0881",
  null
  
)

export default component.exports